/**
 * Product Videos — gallery with thumbnail navigation
 * Clicking a thumbnail switches the main player; other players are paused/stopped.
 */

(function () {
  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.pvInit) return;
    sectionEl.dataset.pvInit = 'true';

    const players = Array.from(sectionEl.querySelectorAll('[data-pv-player]'));
    const thumbs = Array.from(sectionEl.querySelectorAll('[data-pv-thumb]'));
    const autoplay = sectionEl.dataset.pvAutoplay === 'true';
    if (!players.length || !thumbs.length) return;

    function stopPlayer(player) {
      const video = player.querySelector('video');
      if (video) {
        video.pause();
        return;
      }
      const iframe = player.querySelector('iframe');
      if (iframe) {
        // Reset src to the non-autoplay version to stop playback
        const base = iframe.src.split('?')[0];
        const params = iframe.src.includes('youtube') ? '?rel=0&modestbranding=1' : '';
        iframe.src = base + params;
      }
    }

    function startPlayer(player) {
      const video = player.querySelector('video');
      if (video) {
        video.play().catch(function () {});
        return;
      }
      const iframe = player.querySelector('iframe');
      if (iframe && iframe.dataset.autoplaySrc) {
        iframe.src = iframe.dataset.autoplaySrc;
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const index = thumb.dataset.pvThumb;

        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });

        players.forEach(function (player) {
          const isActive = player.dataset.pvPlayer === index;
          if (!isActive && player.classList.contains('is-active')) {
            stopPlayer(player);
          }
          player.classList.toggle('is-active', isActive);
          if (isActive && autoplay) {
            startPlayer(player);
          }
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pv-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
  }
})();
